import { FC, ReactNode } from "react";
import { NavColor } from "../../../types/settings";
import { MenuSection } from "../../../types/settings";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { SideNav } from "./components/side-nav/side-nav";
import { getStyles } from "./styles";
import { TopNav } from "./components/top-nav/top-nav";
import { useMobileNav } from "../../../hooks/useMobileNav";
import { useTheme } from "@emotion/react";

interface IProps {
  children?: ReactNode;
  navColor?: NavColor;
  sections?: MenuSection[];
}

export const VerticalLayout: FC<IProps> = ({
  children,
  sections,
  navColor,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
  const { isOpen, handleOpen } = useMobileNav();

  return (
    <>
      <TopNav onNavOpen={handleOpen} />
      <SideNav
        color={navColor}
        sections={sections}
        isOpen={isOpen}
        onNavOpen={handleOpen}
      />
      <Box sx={styles.verticalLayoutRoot}>
        <Box sx={styles.verticalLayoutContainer}>{children}</Box>
      </Box>
    </>
  );
};
